<template>
 <page>
  
  

  <head-nav :title="$t('language.page_pushnotes')">
    <icon-button-hamburger slot="left"></icon-button-hamburger>
    <icon-button-home slot="right"></icon-button-home>
  </head-nav>


  <scroll-page :pull-reload="true">

    <list-pushnotes/>

   </scroll-page>
  </page>
</template>

<script>

import { mapState } from 'vuex';
import Page from '../pages/Page';
import HeadNav from '../components/HeadNav';
import IconButtonHome from '../components/buttons/IconButtonHome';
import ListPushnotes from '../components/pushnotes/ListPushnotes';
import ScrollPage from '../components/ScrollPage.vue';
import IconButtonHamburger from '../components/buttons/IconButtonHamburger';
import { USER_LEVEL } from '../settings/USER_LEVEL.js';

export default {
  name: 'view-pushnotes-page',
  data:function(){
    return{
    }
  },
  computed:{
     ...mapState(['group','appSettings']),
        computeUserAccess(){
        
         if (this.appSettings.user_level==USER_LEVEL.NONE){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.PARENT){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.TEACHER){
           return true;
         }
         if (this.appSettings.user_level==USER_LEVEL.STUDENT){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.ADMIN){
           return true;
         }
         return false;
       }
  },
  components: {
    ListPushnotes,
    HeadNav,
    IconButtonHome,
    IconButtonHamburger,
    Page,
    ScrollPage,
  },
  methods:{

    
  },// methods{}
  created(){
     
  },
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
